import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { generatePath, useHistory } from 'react-router-dom'

import { AppRoute } from 'routing/AppRoute.enum'
import { Mutations } from 'api/mutations.enum'
import { Queries } from 'api/queries.enum'
import {
    PublishPulseSurveyParams,
    PublishPulseSurveyResponse,
} from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { publishPulseSurvey } from 'api/actions/pulseSurveys/pulseSurveysActions'

export const usePublishPulseSurvey = () => {
    const history = useHistory()

    const queryClient = useQueryClient()

    const mutation = useMutation<PublishPulseSurveyResponse, AxiosError, PublishPulseSurveyParams>({
        mutationFn: publishPulseSurvey,
        mutationKey: [Mutations.publishPulseSurvey],
        onSuccess: async ({ uuid }) => {
            await queryClient.invalidateQueries([Queries.getPulseSurveys])

            await queryClient.invalidateQueries([Queries.getPulseSurveyDetail, { surveyUUID: uuid }])

            history.push(generateCompanyURI(generatePath(AppRoute.PulseSurveyStatus, { id: uuid })))
        },
    })

    return mutation
}
